import styled from 'styled-components';
import { GetColor } from '../../../../style/color';

const PaginationButton = styled.button`
  cursor: pointer;
  margin: 0 5px;
  i {
    font-weight: normal;
    color: ${GetColor.DeepDarkBlue};
  }

  &:disabled {
    color: ${GetColor.GreyScale.Grey40};
    pointer-events: none;

    i {
      color: ${GetColor.GreyScale.Grey40};
    }
  }
`;

export default PaginationButton;
